<script setup>
import { ref, watch, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import ASWLogo from '@/components/ASWLogo.vue'
import ASWNavi from '@/components/ASWNavi.vue'
import ASWHeaderProfile from '@/components/ASWHeaderProfile.vue'
import ASWLanguage from '@/components/ASWLanguage.vue'

const route = useRoute()

// Data
const isOpen = ref(false)

onBeforeMount(() => {
    window.addEventListener('resize', function (event) {
        if (event.target.innerWidth > 1199 && isOpen.value == true) {
            isOpen.value = false
        }
    })
})

watch(
    () => route.path,
    () => {
        if (isOpen.value) {
            isOpen.value = false
            document.body.style = ''
        }
    }
)

watch(isOpen, newVal => {
    const scrollWidth = document.body.offsetWidth - document.body.clientWidth

    const page = document.querySelector('.page')
    const header = document.querySelector('.asw-header')
    const isPageNavOpen = page?.classList.contains('page--translatex')

    if (newVal == true) {
        if (document.body.scrollTop > 0) header.scrollIntoView({ block: 'start', behavior: 'smooth' })

        document.body.style.overflow = 'hidden'

        if (scrollWidth > 0) document.body.style.paddingRight = scrollWidth + 'px'
    } else {
        if (!isPageNavOpen) document.body.style = ''
    }
})
</script>

<template>
    <header class="asw-header">
        <div class="container-fluid asw-header__container">
            <div class="navbar navbar-expand-xl asw-header__navbar">
                <div class="navbar-brand d-flex asw-header__logo">
                    <ASWLogo />
                </div>

                <button
                    type="button"
                    class="asw-header__mobile-btn d-xl-none"
                    :class="{ 'asw-header__mobile-btn--opened': isOpen }"
                    @click="isOpen = !isOpen"
                >
                    <svg width="60" height="60" viewBox="0 0 100 100">
                        <path
                            class="line line1"
                            d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
                        />
                        <path class="line line2" d="M 20,50 H 80" />
                        <path
                            class="line line3"
                            d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
                        />
                    </svg>
                </button>

                <transition name="slidex">
                    <div
                        v-show="isOpen"
                        class="asw-header__navbar-offcanvas"
                        :class="{ 'asw-header__navbar-offcanvas--opened': isOpen }"
                    >
                        <div class="d-flex flex-column flex-xl-row w-100 h-100 position-relative">
                            <div class="asw-header__navi">
                                <ASWNavi />
                            </div>

                            <div class="asw-header__lang">
                                <ASWLanguage />
                            </div>

                            <div class="asw-header__profile">
                                <ASWHeaderProfile />
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="isOpen" class="asw-header__navbar-offcanvas-backdrop" @click="isOpen = false"></div>
                </transition>
            </div>
        </div>
    </header>
</template>
